import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Table } from "../../components/others/Table/index";
import { TableActions } from "../../components/others/TableActions/index";
import LavorisService from "../../services/LavorisService";
import AddBranchOffice from "../others/addBranchOffice";
import DetalleSucursalModal from "../others/detalleSucursal/index";
import UpdateSucursal from "../others/updateSucursal";
import EliminarModal from "../../components/others/EliminarModal";
import { useModal } from "../../hooks";
import { PhoneNumber } from "../../utils/phoneNumber";

const Sucursales = () => {
  const LavorisInstance = LavorisService.getInstance();
  //const reduxStore = useSelector((state: RootState) => state.user);

  const { openModal, closeModal, isActive } = useModal();

  // useStates
  const [data, setData] = useState({
    data: [],
    page: 0,
    totalCount: 0,
  });
  const [tableLoading, setTableLoading] = useState(true);
  const [refreshData, setRefreshData] = useState(false);
  const [itemsPerRow, setItemsPerRow] = useState(10000);
  const [branchName, setBranchName] = useState("");
  const [searchParams, setSearchParams] = useSearchParams("");
  const [companyId, setCompanyId] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  // Table Data Call
  const getOfficesCall = async () => {
    try {
      const sucursales: any =
        await LavorisInstance.CompanyServices.getCompanyOffices(
          itemsPerRow,
          data.page + 1,
        );
      if (sucursales) {
        let responseData = {
          data: sucursales?.branchOffices,
          page: data.page,
          totalCount: sucursales?.totalItems,
        };
        setTableLoading(false);
        setData(responseData);
        return responseData;
      }
    } catch (e) {
      console.log(e);
    }
  };

  // useEffects
  useEffect(() => {
    getOfficesCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshData, itemsPerRow]);

  //Helper Functions
  const HandleDeletion = async () => {
    setIsLoading(true);
    try {
      await LavorisInstance.CompanyServices.deleteBranch(companyId || "");
      closeModal("EliminateModal");
      setRefreshData(!refreshData);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Table
        // onPageChange
        onChangePage={(page: number) => {
          setData({
            ...data,
            page: page,
          });
          setRefreshData(!refreshData);
        }}
        // onChangeRowsPerPage
        onChangeRowsPerPage={(items: number) => {
          setItemsPerRow(items);
        }}
        //CustomToolbarButton React Children
        customToolbarButtons={<></>}
        //Enable Add Button and addOnClick
        enableAdd={false}
        addOnClick={() => {
          setSearchParams({ modalBranchOffice: "active" });
        }}
        //Enable Bulk Delete
        enableBulkDelete={false}
        //
        enablePagination={false}
        // Disable ability to select various rows
        disableMultiSelect={true}
        //Is Loading
        isLoading={tableLoading}
        //Table Data
        data={data?.data}
        // Current Page
        currentPage={data?.page}
        // Total Elements
        totalElements={data?.totalCount}
        searchWidth={'200px'}
        //columns
        columns={[
          { title: "Código Cliente", field: "managerId", maxWidth: '100px' },
          { title: "Nombre", field: "branchOfficeName" },
          { title: "Provincia", field: "province" },
          {
            title: "Teléfono",
            field: "phoneNumber",
            render: (rowData: any) => PhoneNumber(rowData.phoneNumber),
          },
          {
            title: "Acciones",
            render: (rowData: any) => {
              const button = (
                <div className="flex gap-2 justify-center">
                  <TableActions
                    type="View"
                    onClick={() => {
                      setCompanyId(rowData.id);
                      openModal("modalDetalleSucursal", rowData.id);
                    }}
                  />
                  {/* <TableActions
                    type="Edit"
                    onClick={() => {
                      setCompanyId(rowData.id);
                      openModal("modalModificacionSucursal", rowData.id);
                    }}
                  />
                  <TableActions
                    type="Delete"
                    onClick={() => {
                      openModal("EliminateModal", rowData.id);
                      setCompanyId(rowData.id);
                      setBranchName(
                        `${rowData.branchOfficeName}(${rowData.fantasyName})`,
                      );
                    }}
                  /> */}
                </div>
              );
              return button;
            },
            cellStyle: { textAlign: "center" },
            headerStyle: { textAlign: "center" },
          },
        ]}
      />
      {/* {isActive("modalBranchOffice") && (
        <AddBranchOffice
          toggleModal
          urlTittle={"modalBranchOffice"}
          onRefresh={() => {
            setRefreshData(!refreshData);
          }}
          onClose={() => closeModal("modalBranchOffice")}
        />
      )} */}
      {isActive("modalDetalleSucursal") && (
        <DetalleSucursalModal
          toggleModal
          urlTittle={"modalDetalleSucursal"}
          companyId={companyId}
          onClose={() => closeModal("modalDetalleSucursal")}
        />
      )}
      {/* {isActive("modalModificacionSucursal") && (
        <UpdateSucursal
          toggleModal
          urlTittle={"modalModificacionSucursal"}
          companyId={companyId}
          onClose={() => closeModal("modalModificacionSucursal")}
        />
      )} */}
      {/* {isActive("EliminateModal") && (
        <EliminarModal
          toggleModal
          name={branchName}
          handleDeletion={() => HandleDeletion()}
          urlTittle={"EliminateModal"}
          isLoading={isLoading}
        />
      )} */}
    </>

  );
};
export default Sucursales;
